import React from "react";
import Chart from "react-apexcharts";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const PaymentStatusChart = ({ data = [] }) => {
  const { t } = useTranslation("home");

  const labels = data.map((item) => {
    return item.status.charAt(0).toUpperCase() + item.status.slice(1);
  });

  const series = data.map((item) => Number(item.total));

  const totalPayments = series.reduce(
    (sum, item) => sum + item,
    0
  );

  const options = {
    chart: {
      type: "pie",
      toolbar: {
        show: false,
      },
    },

    labels,

    colors: [
      "#22c55e",
      "#f59e0b",
      "#ef4444",
      "#3b82f6",
      "#8b5cf6",
    ],

    legend: {
      position: "bottom",
      fontSize: "14px",
    },

    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(1) + "%";
      },
    },

    tooltip: {
      y: {
        formatter: function (val) {
          return `${val} ${t('paymentStatus.paymentsCount')}`;
        },
      },
    },

    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <Card className="shadow-md">
      <CardHeader
        floated={false}
        shadow={false}
        className="bg-white rounded-none px-6 py-4"
      >
        <div className="flex justify-between items-center">

          <div>
            <Typography variant="h5">
              {t('paymentStatus.title')}
            </Typography>

            <Typography
              variant="small"
              color="gray"
            >
              {t('paymentStatus.description')}
            </Typography>
          </div>

          <Typography
            variant="h6"
            color="green"
          >
            {totalPayments} {t('paymentStatus.paymentsCount')}
          </Typography>

        </div>
      </CardHeader>

      <CardBody>

        <Chart
          options={options}
          series={series}
          type="pie"
          height={360}
        />

      </CardBody>
    </Card>
  );
};

export default PaymentStatusChart;